import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const PushSend24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25 6.21985C8.25 5.51764 8.84753 4.9201 9.54975 4.9201H12.5625C12.9767 4.9201 13.3125 4.58432 13.3125 4.1701C13.3125 3.75589 12.9767 3.4201 12.5625 3.4201H9.54975C8.01911 3.4201 6.75 4.68921 6.75 6.21985V17.8711C6.75 19.4003 8.02083 20.6705 9.55002 20.6701H14.4503C15.9808 20.6705 17.25 19.4017 17.25 17.8711V13.7326C17.25 13.3184 16.9142 12.9826 16.5 12.9826C16.0858 12.9826 15.75 13.3184 15.75 13.7326V15.7951H8.25V6.21985ZM8.25 17.2951V17.8711C8.25 18.5718 8.8488 19.1704 9.54948 19.1701H14.4503C15.1523 19.1704 15.75 18.5731 15.75 17.8711V17.2951H8.25Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1473 3.04656C20.4017 2.93639 20.6833 2.90498 20.9557 2.95642C21.229 3.00803 21.4804 3.14061 21.6774 3.33694C21.8743 3.53328 22.0077 3.7843 22.0602 4.05741C22.1126 4.33009 22.0819 4.61221 21.9722 4.86724L21.9716 4.86845L19.084 11.593C18.9796 11.8357 18.808 12.0438 18.5896 12.1924C18.3711 12.3409 18.1148 12.424 17.8507 12.4317C17.5866 12.4395 17.3259 12.3717 17.099 12.2363C16.8722 12.1009 16.6888 11.9035 16.5703 11.6674L15.4956 9.51727L13.3471 8.44301C13.1105 8.32453 12.9123 8.14058 12.7768 7.91332C12.6413 7.68605 12.5737 7.42473 12.5819 7.16026C12.5902 6.89578 12.674 6.63919 12.8234 6.42081C12.9725 6.20279 13.1809 6.03195 13.4239 5.92839L13.4251 5.92787L20.1473 3.04656ZM20.4824 4.5349L14.238 7.21143L16.3901 8.28745C16.5352 8.36004 16.6529 8.47776 16.7255 8.62294L17.8021 10.7767L20.4824 4.5349Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
